import { NgxLoggerLevel } from 'ngx-logger';
import { Environment } from './environment.model';

export const environment: Environment = {
  environment: 'qa',
  production: false,
  authentication: {
    clientID: 'ca5bde45-01b7-4cfb-8983-0df20e654381',
    clientSecret: '8e767da8-1f51-4df0-8f93-16dbf05dbaa2',
  },
  capawesome: {
    liveUpdatesEnabled: true,
  },
  qrCodeExactLength: 13,
  intercom: false,
  sqliteDatabase: {
    name: 'eventlinkdb',
    version: 1,
    encrypted: false,
    mode: 'no-encryption',
  },
  api: {
    authHeader: 'BASIC',
    endpoint: 'https://api-qa.eventlink.com/',
    maxWaiting: 10000,
    external: 'https://api-qa.eventlink.com/',
    webcal: 'webcal://api-qa.eventlink.com/',
    V2Endpoint: 'https://api-qa.eventlink.com/api/',
    support: 'https://eventlink.com/contact-support/',
  },
  dwolla: {
    mode: 'sandbox',
    url: 'https://api-sandbox.dwolla.com',
    domain: 'dashboard-sandbox.dwolla.com',
  },
  stripe: {
    stripeTestMode: false,
    tokenProviderEndpoint: 'https://api-qa.eventlink.com/api/Stripe/GetTerminalConnectionToken',
    publishableKey:
      'pk_test_51HC86QDLDNlxUPbbCctBzp6rT3v6R9gcE6LcJ5SyOsQDtAulRbBOolhm4gkjH8Snfc1zFpfw7Qf1Yp6ql5SyTtmo00Y3MZmrsM',
    dashboardUrlBase: 'https://dashboard.stripe.com/test/',
  },
  logging: {
    logLevel: NgxLoggerLevel.DEBUG,
    serverLogLevel: NgxLoggerLevel.OFF,
    enabled: true,
    analyticsEndpoint: 'https://eventlink-prod-funcs-nodejs.azurewebsites.net/api/LogEvent',
    analyticsEnv: 'qa',
  },
  studio: {
    endpoint: 'https://eventlink-prod-funcs-nodejs.azurewebsites.net/api/RenderStudioImage',
  },
  tickets: {
    purchase: 'https://public-qa.eventlink.com/find-tickets',
    sitesUrl: 'https://websites-qa.eventlink.com/s/',
  },
  moment: {
    format: 'M/D/YYYY h:mm A',
  },
  ui: {
    public: 'https://public-qa.eventlink.com/',
    sites: 'https://sites-qa.eventlink.com/',
    sitesV2: 'https://websites-qa.eventlink.com/',
  },
};
